module.exports = __webpack_public_path__ + "static/media/about.29b3d4a6.md";